export default {
    message: {
        hello: '你好，世界！',
        greeting: '早上好, 世界!'
    }
}